module.exports = __webpack_public_path__ + "static/media/DSC_0164-2.69bab8fb.jpg";